import type { TrackingFn } from '@change-corgi/core/react/tracking';
import { openWindow } from '@change-corgi/core/window';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

export function shareReddit(
	title: string,
	url: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): void {
	const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
	openWindow(redditUrl);
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
